/** @format */
import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { Card, CardHeader } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import { useDispatch } from 'react-redux';
import { FeatureTypes } from '../../modules/features/FeaturesTypes';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoOperationSetup from '../../interfaces/platform/MvnoOperatorSetup';
import CardBody from '../../components/Card/CardBody';
import { SimCardServiceTypeProfileUsageCollection } from '../../interfaces/platform/SimCardServiceTypeProfileUsage';
import { ComponentByTypeConfiguration } from './component/ComponentByTypeConfiguration';

type ServiceProfileCustomFeaturesListType = {
    mvnoOperatorSetup: MvnoOperationSetup | null;
};

export const ServiceProfileCustomFeaturesList: FunctionComponent<ServiceProfileCustomFeaturesListType> = ({ mvnoOperatorSetup }): ReactElement => {
    const dispatch = useDispatch();
    const listType = new FeatureTypes(process.env);
    const [partnerAllowedList, setPartnerAllowedList] = useState<Array<{ typeId: number; id: number; apiId: string }> | null>(null);

    const featureTypes = new FeatureTypes(process.env);

    useEffect(() => {
        if (mvnoOperatorSetup && partnerAllowedList === null) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_type_profile_usages')),
                'load_sim_card_services_sim_card_service_type_to_mvno_tariffs_' + mvnoOperatorSetup.id,
                [
                    { name: 'mvnoOperatorSetupId', value: mvnoOperatorSetup.id },
                    { name: 'pagination', value: false },
                ],
                [],
                (data: SimCardServiceTypeProfileUsageCollection): void => {
                    const elements: Array<{ typeId: number; id: number; apiId: string }> = [];
                    for (let i = 0; i < data['hydra:member'].length; i++) {
                        elements.push({
                            typeId: data['hydra:member'][i].simCardTypeId,
                            id: data['hydra:member'][i].id,
                            apiId: data['hydra:member'][i]['@id'] ?? '',
                        });
                    }
                    setPartnerAllowedList(elements);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, mvnoOperatorSetup, partnerAllowedList]);

    return (
        <Card>
            {mvnoOperatorSetup && (
                <React.Fragment>
                    <CardHeader title={<I18n trans="prov:profile.allowed_component" valueObject={{ partner: mvnoOperatorSetup.displayName }} />} />
                    <CardBody>
                        <GridContainer>
                            {mvnoOperatorSetup &&
                                partnerAllowedList &&
                                featureTypes.nsType.map((types) => {
                                    return (
                                        <ComponentByTypeConfiguration
                                            mvnoOperatorSetup={mvnoOperatorSetup}
                                            partnerAllowedList={partnerAllowedList}
                                            serviceType={types}
                                            key={types}
                                        />
                                    );
                                })}
                        </GridContainer>
                    </CardBody>
                </React.Fragment>
            )}
        </Card>
    );
};
